import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";

const connectionReqSearch = {
  facilityID: 0,
  publicUserLastName: "",
  publicUserFirstName: "",
  inmateResidentID: "",
  inmateLastName: "",
  inmateFirstName: "",
  fromDate: getPastDate(6),
  toDate: getCurrentDate(),
  pageNo: 1,
  rowCountPerPage: 10,
  sortField: "RequestSentDate DESC",
};

// Create slice

const name = "connectionRequest";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const connectionRequestActions = { ...slice.actions, ...extraActions };
export const connectionRequestReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    crExcelList: [],
    connectionRequestList: [],
    approveCRStatus: [],
    rejectCRStatus: [],
    loading: false,
    error: null,
    connectionReqSearchData: connectionReqSearch,
    connectionReqSearch
  };
}

function createReducers() {
  return {
    clearDeleteCRExcelList,
    clearApproveStatus,
    clearRejectStatus,
    setConnectionReqSearchData,
    resetConnectionReqSearchData,
    setConnectionRequestList
  };
  /// clear funcs

  function setConnectionReqSearchData(state, action) {
    state.connectionReqSearchData = action && action.payload;
  }
  function resetConnectionReqSearchData(state) {
    state.connectionReqSearchData = { ...connectionReqSearch };
  }
  function setConnectionRequestList(state, action) {
    state.connectionRequestList = action.payload;
  }
  function clearDeleteCRExcelList(state) {
    state.crExcelList = [];
  }
  function clearApproveStatus(state) {
    state.approveCRStatus = [];
  }
  function clearRejectStatus(state) {
    state.rejectCRStatus = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/ConnectionRequest`;

  return {
    LoadConnectionRequestList: LoadConnectionRequestList(),
    ApproveConnectionRequest: ApproveConnectionRequest(),
    RejectConnectionRequest: RejectConnectionRequest(),
  };

  // load grid
  function LoadConnectionRequestList() {
    return createAsyncThunk(
      `${name}/LoadConnectionRequestList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadConnectionRequestList`,
          params
        );
      }
    );
  }

  /// Approve ConnectionRequest ..
  function ApproveConnectionRequest() {
    return createAsyncThunk(
      `${name}/ApproveConnectionRequest`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/ApproveConnectionRequest`,
          params
        );
      }
    );
  }

  ///Reject ConnectionRequest..
  function RejectConnectionRequest() {
    return createAsyncThunk(
      `${name}/RejectConnectionRequest`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/RejectConnectionRequest`,
          params
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    // grid load
    .addCase(extraActions.LoadConnectionRequestList.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(
      extraActions.LoadConnectionRequestList.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.crExcelList = action.payload;
        } else {
          state.connectionRequestList = action.payload;
        }
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadConnectionRequestList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )
    // Approve ConnectionRequest status
    .addCase(extraActions.ApproveConnectionRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.ApproveConnectionRequest.fulfilled,
      (state, action) => {
        state.loading = false;
        state.approveCRStatus = action.payload;
      }
    )
    .addCase(
      extraActions.ApproveConnectionRequest.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    /// Reject Connection Request
    .addCase(extraActions.RejectConnectionRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.RejectConnectionRequest.fulfilled,
      (state, action) => {
        state.loading = false;
        state.rejectCRStatus = action.payload;
      }
    )
    .addCase(extraActions.RejectConnectionRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
